/* src/app/settings/pages/user-role-new/user-role-new.component.scss */
/*# sourceMappingURL=user-role-new.component.css.map */
